module.exports = __webpack_public_path__ + "static/media/22_tn.3913db85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/22_tn.jpg
// module id = 160
// module chunks = 0